import React , {useEffect , useState} from "react";
import Slider from "react-custom-slider";

const CustomSlider = ({value , onChange , name , mini, maxi , units}) => {

  const min = mini;
  const max = maxi;
  const numberOfMarkers = 6;
// 
  const markers = Array.from(
    { length: numberOfMarkers },
    (_, index) => min + (index * (max - min)) / (numberOfMarkers - 1)
  );


  return (
    <div className="absolute top-[48px] left-[-283px] bg-white px-6 py-6 border-2 border-[#d3d3d3] rounded-lg">
     {/* <div className="absolute left-[45%] top-[33%] transform -translate-x-1/2 -translate-y-1/2 bg-white px-6 py-6 border-2 border-[#d3d3d3] rounded-lg shadow-lg z-50"> */}

      {/* Slider */}
      {/* <div className="flex justify-between ">
        <span>{min} kg</span>
        <span>{max} kg</span>
      </div> */}

      {/* Slider */}
      <div className="relative w-full ">
        <Slider
          name = {name}
          value={value}
          showValue={true}
          markersSize={25}
          trackLength={500}
          // markers={numberOfMarkers}
          // showMarkers={false}
          onChange={(newValue) => {
            onChange(newValue)
            
            console.log("Slider value " , newValue)
          }}
          valueRenderer={(value) => `${value}`}
          trackColor="#D8F1FF"
          trackThickness={8}
          max={max}
          fillColor="#258CFB"
          fontSize={12}
          handlerShape="rounded"
          valueLabelActiveColor="#258CFB"
          valueLabelColor="#258CFB"
          valueLabelStyle={{
            color: "#fff",
            fontStyle: "bold",
            paddingBottom: "20px",
            backgroundColor: "#258CFB",
          }}
          style={{
            // borderBottom: "2px solid gray",
            // paddingBottom: "6px",
            borderLeft: "2px red",
          }}
        />

        <div className=" relative w-full ">
          <div className="absolute h-6 ml-6  mb-4 flex w-[95%] justify-between">
            {markers.map((marker, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="h-14 w-[1px] bg-[#D4D4D4]"></div>
                <span className="text-sm text-gray-600">{marker} {units}</span>
                {index !== markers.length - 1 && (
                  <div
                    className="h-[1px] bg-[#D4D4D4]  absolute w-[20%]"
                    style={{ left: `${((marker - min) / (max - min)) * 100}%` }}
                  ></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSlider;



// import React, { useEffect, useState } from "react";
// import Slider from "react-custom-slider"; // Replace with your actual Slider library

// const CustomSlider = ({ val, name, mini, maxi }) => {
//   const [value, setValue] = useState(val || 0); // Initialize with `val` prop or default to 0

//   const min = mini;
//   const max = maxi;
//   const numberOfMarkers = 6;

//   // Generate markers based on the min and max
//   const markers = Array.from(
//     { length: numberOfMarkers },
//     (_, index) => min + (index * (max - min)) / (numberOfMarkers - 1)
//   );

//   // Update the state when `val` prop changes
//   useEffect(() => {
//     if (val !== undefined) {
//       setValue(val);
//     }
//   }, [val]);

//   return (
//     <div className="absolute top-[48px] left-[-283px] bg-white px-6 py-6 border-2 border-[#d3d3d3] rounded-lg">
//       {/* Slider */}
//       <div className="relative w-full">
//         <Slider
//           name={name}
//           value={value}
//           showValue={true}
//           markersSize={25}
//           trackLength={500}
//           onChange={(value) => {
//             setValue(value); // Update state
//             console.log("Slider Value:", value); // Log value for debugging
//           }}
//           valueRenderer={(value) => `${value}`}
//           trackColor="#D8F1FF"
//           trackThickness={8}
//           max={max}
//           fillColor="#258CFB"
//           fontSize={12}
//           handlerShape="rounded"
//           valueLabelActiveColor="#258CFB"
//           valueLabelColor="#258CFB"
//           valueLabelStyle={{
//             color: "#fff",
//             fontStyle: "bold",
//             paddingBottom: "20px",
//             backgroundColor: "#258CFB",
//           }}
//           style={{
//             borderLeft: "2px solid red",
//           }}
//         />

//         {/* Markers */}
//         <div className="relative w-full">
//           <div className="absolute h-6 ml-6 mb-4 flex w-[95%] justify-between">
//             {markers.map((marker, index) => (
//               <div key={index} className="flex flex-col items-center">
//                 <div className="h-14 w-[1px] bg-[#D4D4D4]"></div>
//                 <span className="text-sm text-gray-600">{marker} kg</span>
//                 {index !== markers.length - 1 && (
//                   <div
//                     className="h-[1px] bg-[#D4D4D4] absolute w-[20%]"
//                     style={{ left: `${((marker - min) / (max - min)) * 100}%` }}
//                   ></div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomSlider;
